globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Modules = appCustomerSpace.Modules || {};

appCustomerSpace.Modules.InputButtons = (function() {

  function InputButtons($button) {
    this.$button     = $button;
    this.$color      = $button.data("color");
    this.$type       = $button.data("type");
    this.$checkbox   = $button.find("input[type='checkbox']");
    this.$icon       = $button.find("i");

    this.init();
  }

  InputButtons.init = function($html) {
    $html.find(".btn-checkboxes-group .btn-checkbox").each(function(){
      new InputButtons($(this));
    })
  }

  InputButtons.prototype = {
    init: function() {
      var _this = this;

      _this._validateType();
      _this.events();
    },
    events: function() {
      var _this = this;

      if(_this.$checkbox.length && _this.$color.length && _this.$type.length) {
        _this._toggleColors();
      }
    },
    _validateType: function() {
      var _this = this;

      if(!["border", "bg"].includes(_this.$type)) {
        console.log("Wrong type found for button checkboxes");
        return false
      }
    },
    _toggleColors: function() {
      var _this             = this,
          mainClass         = `${_this.$type}-${_this.$color}`,
          mainHoverClass    = `${_this.$type}-${_this.$color}-hover`,
          textClass         = `text-${_this.$color}`,
          textHoverClass    = `text-${_this.$color}-hover`;

      if(_this.$checkbox.is(":checked")) {
        _this.$button.addClass(mainClass);
        _this.$button.addClass(mainHoverClass);

        if(_this.$icon.length&& _this.$type == "border") {
          _this.$icon.addClass(textClass);
          _this.$icon.addClass(textHoverClass);
        }
      }

      _this.$checkbox.on("change", function() {
        _this.$button.toggleClass(mainHoverClass);
        _this.$button.toggleClass(mainClass);

        if(_this.$icon.length && _this.$type == "border") {
          _this.$icon.toggleClass(textClass);
        }
      });
    }
  }

  return InputButtons;

})();
